import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  PatternTypeCategoryBean,
  PatternTypeCategorySearchCriteria,
  RestPatternTypeCategoryListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class TypeCategoryListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  editPatternTypeCategory = (e, val, rowData) => {
    if (e.detail === 1) this.props.editPatternTypeCategory(val);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  deleteTypeCategory = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteTypeCategory(val, rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  clickGoButton = (e) => {
    if (e.detail === 1) this.props.clickGoButton();
  };
  render() {
    let patternTypeCategory_list = this.props.patternTypeCategory_list;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">Type Category</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                name="code"
                onChange={this.props.onChange}
                value={this.props.patternTypeCategoryData.code}
                style={{ "text-transform": "uppercase" }}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.clickGoButton(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {patternTypeCategory_list != null ? (
              <tbody>
                {patternTypeCategory_list.map((ln, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editPatternTypeCategory(e, ln.code, ln)
                        }
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td>{ln.description}</td>
                    <td>{ln.companyCode}</td>
                    <td>{ln.isActive}</td>
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.deleteTypeCategory(e, ln.code, ln)}
                      >
                        {<DeleteIcon />}
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {patternTypeCategory_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class TypeCategoryEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }
  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  render() {
    let patternTypeCategoryData = this.props.patternTypeCategoryData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              type="text"
              name="companyCode"
              onChange={this.onChange}
              value={patternTypeCategoryData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>TypeCategory </FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter Code"
              onChange={this.onChange}
              value={patternTypeCategoryData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>TypeCategory Name</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={patternTypeCategoryData.description}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Active</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputCheckbox
              name="isActive"
              onChange={this.onChange}
              type="checkbox"
              checked={patternTypeCategoryData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class TypeCategoryList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      patternTypeCategory_list: [],
      pageTitle: "Type Category",
      patternTypeCategoryData: new PatternTypeCategoryBean(),
      pageList: new PageListBean(),
      criteria: new PatternTypeCategorySearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isListFormOpen: true,
      isEntryFormOpen: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
    this.moduleCaption = "Style Type";
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let patternTypeCategoryData = new PatternTypeCategoryBean();
    patternTypeCategoryData.companyCode = this.companyCode;
    this.loadPage(1);
    this.setState({ patternTypeCategoryData: patternTypeCategoryData });
  }
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  onChange = (e) => {
    let patternTypeCategoryData = this.state.patternTypeCategoryData;
    patternTypeCategoryData[e.target.name] = e.target.value;
    this.setState({ patternTypeCategoryData: patternTypeCategoryData });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadPatternTypeCategoryPage(criteria, pageInput);
  };

  save = () => {
    this.savePatternTypeCategory();
  };
  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeEntryForm();
  };
  cleardata = () => {
    let patternTypeCategoryData = new PatternTypeCategoryBean();
    patternTypeCategoryData.companyCode = this.companyCode;
    this.setState({
      patternTypeCategoryData: patternTypeCategoryData,
    });
  };
  clickGoButton = () => {
    let patternTypeCategoryData = this.state.patternTypeCategoryData;
    this.editPatternTypeCategory(patternTypeCategoryData.code);
  };
  openEntryForm = () => {
    this.setState({
      isListFormOpen: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
      isEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowAlert: false,
    });
  };
  closeEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isDisableFields: false,
    });
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.clickGoButton();
    }, 200);
  };
  loadPageResponse = (response) => {
    if (
      response.data != null &&
      response.data.patternTypeCategoryPageList != null &&
      response.data.patternTypeCategoryPageList.patternTypeCategories != null
    ) {
      let patternTypeCategory_list =
        response.data.patternTypeCategoryPageList.patternTypeCategories;
      patternTypeCategory_list.map((Info) => {
        if (Info.isActive == true) {
          Info.isActive = "True";
        } else {
          Info.isActive = "False";
        }
      });
      let pageList = this.state.pageList;
      pageList.currentPage =
        response.data.patternTypeCategoryPageList.currentPage;
      pageList.pageSize = response.data.patternTypeCategoryPageList.pageSize;
      pageList.totalCount =
        response.data.patternTypeCategoryPageList.totalCount;
      this.setState({
        patternTypeCategory_list: patternTypeCategory_list,
        pageList: pageList,
      });
    }
  };
  loadPatternTypeCategoryPage = (criteria, pageList) => {
    let requestInput = new RestPatternTypeCategoryListRequest();
    requestInput.searchCriteria = criteria;
    requestInput.pageInput = pageList;
    if (SecurityAccessManager.TypeCategoryMaintenanceView_IsAccessible()) {
      MasterService.getPatternTypeCategoryPageList(
        requestInput,
        this.loadPageResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadSaveResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeEntryForm();
  };
  savePatternTypeCategory = () => {
    let input = this.state.patternTypeCategoryData;
    if (input.isFetched == true) {
      if (SecurityAccessManager.TypeCategoryMaintenanceEdit_IsAccessible()) {
        MasterService.updatePatternTypeCategory(
          input,
          this.loadSaveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.TypeCategoryMaintenanceCreate_IsAccessible()) {
        MasterService.createPatternTypeCategory(
          input,
          this.loadSaveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadEditResponse = (response) => {
    if (response.data != null) {
      if (response.data.patternTypeCategoryBean != null) {
        let patternTypeCategoryData = response.data.patternTypeCategoryBean;
        this.setState({
          patternTypeCategoryData: patternTypeCategoryData,
        });
        this.disable();
      }
    }
    this.openEntryForm();
  };
  editPatternTypeCategory = (code) => {
    let readRequest = new RestReadRequest();
    readRequest.companyCode = this.companyCode;
    readRequest.code = code;
    if (SecurityAccessManager.TypeCategoryMaintenanceView_IsAccessible()) {
      MasterService.readPatternTypeCategory(
        readRequest,
        this.loadEditResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteTypeCategory = (code, rowData) => {
    //
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.patternTypeCategory_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ patternTypeCategory_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isListFormOpen && (
          <TypeCategoryListForm
            {...this.state}
            clickGoButton={this.clickGoButton}
            editPatternTypeCategory={this.editPatternTypeCategory}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            deleteTypeCategory={this.deleteTypeCategory}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        {this.state.isEntryFormOpen && (
          <TypeCategoryEntryForm {...this.state} onChange={this.onChange} />
        )}
      </div>
    );
  }
}

function TypeCategoryAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <TypeCategoryList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default TypeCategoryAttributeModule;
